import React from 'react';
import { GetStaticProps } from 'next';
import { flatMap, filter } from 'lodash';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { initializeApp } from '@state/initializeApp';
import { ContentfulApi } from '@model/contentful/service';
import { CmsPages } from '@model/contentful';
import SitemapDestinationPageLayout, {
  SitemapDestinationPageLayoutProps
} from '@layout/SitemapPageLayout/SitemapDestinationPageLayout';
import { Name } from '@model/iceberg';
import { Page } from '@model/common';
import { ContentApi } from '@model/iceberg/service/content';
import { Revalidate } from '@model/config/revalidate';

const SitemapDestinationPage = (props: SitemapDestinationPageLayoutProps) => {
  return <SitemapDestinationPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps(
  (store) =>
    async ({ params: { destination: query } }: any) => {
      const props = await initializeApp(store, async () => {
        const cmsConfig = await new ContentfulApi().getPageConfig({ includeLevel: 3, pageId: CmsPages.SITEMAP_HOME });
        const path = query.join('/');
        const destination = await new ContentApi().getDestination(path);

        return {
          cmsConfig,
          path,
          destination: destination[0] || null
        };
      });
      return {
        ...props,
        revalidate: Revalidate.HALF_HOUR
      };
    }
);

export async function getStaticPaths() {
  const continents = await new ContentApi().getGeography();
  const countries = flatMap(continents, 'countries');
  const regions = flatMap(countries, 'regions');
  const destinations = filter(countries.concat(regions), 'isDestination');

  const paths: Array<string> = destinations.map((name: Name) => Page.SITEMAP.concat('/').concat(name.path));

  return { paths, fallback: false };
}

export default withGlobalProvider(SitemapDestinationPage);
